module.exports = __webpack_public_path__ + "static/media/TommyShirtLabel.3e77bbb3.jpg";